import { render, staticRenderFns } from "./DetailSpecifications.vue?vue&type=template&id=012a5124&"
import script from "./DetailSpecifications.vue?vue&type=script&lang=js&"
export * from "./DetailSpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports